import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {PTPLocationDto, PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-ptp-location",
    templateUrl: "./ptp-location.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PTPLocationComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private router: Router,
        private message: NzMessageService
    ) {}

    loading = true;
    locations: PTPLocationDto[] = [];

    async ngOnInit() {
        await this.getData();
    }

    getData = async () => {
        this.loading = true;
        try {
            this.locations = await lastValueFrom(this.api.getApiConfigurePtpLocations());
        } catch (e) {
            this.message.error("Failed to fetch locations");
            console.log(e);
        } finally {
            this.loading = false;
        }
    };

    addLocation = () => {
        this.router.navigateByUrl("/configure/ptplocationcreate");
    };

    editLocation = (id: number) => {
        this.router.navigate(["/configure/ptplocationedit"], {queryParams: {id}});
    };

    deleteLocation = async (id: number) => {
        this.loading = true;
        try {
            await lastValueFrom(this.api.deleteApiConfigurePtpLocationsId(id));
            this.message.success("Location deleted");
            await this.getData();
        } catch (e) {
            this.message.error("Failed to delete location");
            console.log(e);
            this.loading = false;
        }
    };
}
